  import React, { useEffect, useState } from "react";
  import { DataTable } from "primereact/datatable";
  import { Column } from "primereact/column";
  import { formateDateTime } from "../../../../services/date_service";
  import { InputText } from "primereact/inputtext";
  import * as Yup from "yup";
  import classNames from "classnames";
  import { Formik, useFormik } from "formik";
  import { Dropdown } from "primereact/dropdown";
  import { Button } from "primereact/button";
  import { ColumnGroup } from "primereact/columngroup";
  import { Row } from "primereact/row";
  import moment from "moment";
  import * as XLSX from "xlsx";
  import appUrl from "../../../config/appUrl";
  import { FilterMatchMode } from "primereact/api";
  import { useLocation } from "react-router-dom";
  import { Checkbox } from "primereact/checkbox"
  const CollectionReports = ({ onHide, getBoothList, addEditBooth, boothId }) => {
    const [dashList, setDashList] = useState([]);
    const [dashStat, setDashStat] = useState([]);
    const [showFilters, setShowFilters] = useState(false);
    const [appliedFilters, setAppliedFilters] = useState(0);
    const [totalFee, setTotalFee] = useState("");
    const [siteList, setSiteList] = useState([]);
    const [boothList, setBoothList] = useState("");
    const [exportLoading, setExportLoading] = useState(false);
    const [booothId, setBooothId] = useState("");
    const [siteId, setSiteId] = useState("");
    const [loading, setLoading] = useState(false);
    const [selectedUser, setSelectedUser] = useState("");
    const [siteValue, setSitevalue] = useState(null);
    const [filteredUserList, setFilteredUserList] = useState([]);
    const [userList, setUserList] = useState([]);
    const [globalFilterValue, setGlobalFilterValue] = useState("");
    const [initialized, setInitialized] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(10);
    const [vehicleTypeList, setVehicleTypeList] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [selectedVehicleType, setSelectedVehicleType] = useState(null);
    const [dateWiseDataOnly, setDateWiseDataOnly] = useState(false);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    
    const date = new Date();

    let currentDate = moment(date).format("YYYY-MM-DD");

    const [fromDate, setFromDate] = useState(currentDate);
    const [toDate, setToDate] = useState(currentDate);
    const [filters, setFilters] = useState({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const onGlobalFilterChange = (e) => {
      const value = e.target.value;
      setGlobalFilterValue(value);
      getDashData(1, currentPageSize, value);  // searchText passed here
      setCurrentPage(1);
    };


    const validationSchema = Yup.object().shape({
      // name: Yup.mixed().required("This field is required."),
    });

    const formik = useFormik({
      validationSchema: validationSchema,
      initialValues: {
        boothId: "",
        fromDate: "",
        toDate: "",
        site: "",
      },
    });

    const isFormFieldValid = (name) =>
      !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
      return (
        isFormFieldValid(name) && (
          <small className="p-error">{formik.errors[name]}</small>
        )
      );
    };
    const getUserList = async () => {
      try {
        setUserList([]);
        const response = await fetch(`${appUrl.BASE_URL}user`);
        const data = await response.json();

        // Filter users with role 'login_user'
        const filteredUsers = data.filter((user) => user.role === "login_user");

        setUserList(filteredUsers);
        setFilteredUserList(filteredUsers); // Initially, set the filtered list to the entire list
      } catch (error) {
        console.error(error);
        setUserList([]);
      }
    };

   

    useEffect(() => {
      // Count applied filters based on selected values
      const count = [
        formik.values.site,
        formik.values.boothId,
        fromDate,
        toDate,
      ].filter((val) => val).length;
      setAppliedFilters(count);
    }, [formik.values.site, formik.values.boothId, fromDate, toDate]);
    console.log('siteValue:', siteValue);

    useEffect(() => {
      if (initialized && fromDate && toDate) {
        getDashData(1, currentPageSize);
      }
    }, [fromDate, toDate, siteId, initialized]);
    useEffect(() => {
    const fromDateParam = queryParams.get("fromDate");
    const toDateParam = queryParams.get("toDate");
    const siteParam = queryParams.get("site");

    if (fromDateParam && toDateParam) {
      setFromDate(fromDateParam);
      setToDate(toDateParam);
      if (siteParam) {
        formik.setFieldValue("site", siteParam);
        setSiteId(siteParam);
      }
      getDashData(1, currentPageSize, globalFilterValue);
    }
  }, []);

  useEffect(() => {
    const siteParam = queryParams.get("site");
    
    if (siteParam) {
      formik.setFieldValue("site", siteParam);  // pre-select
      setSiteId(siteParam);
      setSitevalue(siteList?.find(s => s._id === siteParam) || null);
    }
  }, [siteList]);
    
    const getDashData = async (page = 1, pageSize = 10, searchText = '') => {
      try {
        setLoading(true);
        setDashList([]);
        setTotalFee(0);

        const response = await fetch(
          `${appUrl.BASE_URL}parkingHistory/getCollectionData?fromDate=${fromDate || ''}&toDate=${toDate || ''}&booth=${formik.values.boothId || ''}&vehicleType=${selectedVehicleType || ''}&site=${siteId || ''}&user=${selectedUser || ''}&searchText=${searchText}&page=${page}&pageSize=${pageSize}&excelExport=false`
        );

        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

        const result = await response.json();

        const allData = result?.data?.data || [];
        const totalFeeFromApi = result?.data?.totalCollection || 0;
        const totalRecordsFromApi = result?.data?.totalRecords || 0;

        // 🔍 Frontend Filtering (In case backend fails to filter)
        const filteredData = searchText
          ? allData.filter(item =>
            (item?.vehicleRegNumber || '')
              .toLowerCase()
              .includes(searchText.toLowerCase())
          )
          : allData;

        // Map the final data for the table
        const myData = filteredData.map(item => ({
          _id: item._id,
          vehicleRegNumber: item?.vehicleRegNumber,
          vehicleType: item?.vehicleType?.name,
          checkInBy: item?.checkInBy?.boothId?.name,
          name: item?.checkInLoginUser?.firstName,
          checkInTime: item?.checkInTime ?? null,
          checkOutBy: item?.checkOutBy?.boothId?.name,
          checkOutTime: item?.checkOutTime ?? null,
          parkingFee: item?.parkingFee,
          parkedTime: item?.parkedTime,
          site: item?.site?.site,
          exempted: item?.exempted,
        }));

        setDashList(myData);
        setTotalFee(totalFeeFromApi);
        setTotalRecords(searchText ? filteredData.length : totalRecordsFromApi);  // 👈 Important for pagination
        setLoading(false);
      } catch (error) {
        console.error(error);
        setDashList([]);
        setTotalFee(0);
        setTotalRecords(0);
        setLoading(false);
      }
    };

    useEffect(() => {
      getDashData(1, currentPageSize);  // Always start from page 1 on new search
      setCurrentPage(1);
    }, []);

    // useEffect(() => {
    //   if (
    //     formik.values.site !== "" ||
    //     formik.values.boothId !== "" ||
    //     (fromDate !== "" && toDate !== "") ||
    //     selectedUser !== ""
    //   ) {
    //     if (initialized) {
    //       getDashData();
    //     }
    //   }
    // }, [
    //   fromDate,
    //   toDate,
    //   formik.values.boothId,
    //   formik.values.site,
    //   selectedUser,
    //   initialized,
    // ]);

    const getBoothId = async () => {
      try {
        let apiUrl = `${appUrl.BASE_URL}booth/getBySite`;
        if (siteId) {
          apiUrl += `?siteId=${siteId}`;
        }
        const response = await fetch(apiUrl);
        const data = await response.json();
        setBoothList(data?.data);
        console.log("data", data?.data);
      } catch (error) {
        console.error(error);
      }
    };

    const getSiteList = async () => {
      try {
        const response = await fetch(`${appUrl.BASE_URL}Site/allV2`);
        const data = await response.json();
        setSiteList(data?.data);
      } catch (error) {
        console.error(error);
      }
    };

    useEffect(() => {
      if (formik.values.site !== null && formik.values.site !== "") {
        getBoothId();
      }
      getSiteList();
    }, [formik.values.site]);



    const exportExcel = async () => {
      setExportLoading(true);

      try {
        const response = await fetch(
          `${appUrl.BASE_URL}parkingHistory/getCollectionData?fromDate=${fromDate ? `${fromDate}` : ''}&toDate=${toDate ? `${toDate}T00:00:00Z` : ''}&booth=${formik.values.boothId ? formik.values.boothId : ''}&site=${siteId ? siteId : ''}&user=${selectedUser ? selectedUser : ''}&excelExport=true`
        );

        const result = await response.json();
        const exportDataRaw = result?.data?.data || [];

        // ✅ Step 1: Map data in your desired order
        const exportData = exportDataRaw.map(item => [
          item.vehicleRegNumber || '',
          item.vehicleType.name || '',
          item.site.location || '',
          item.checkInBy.boothId.name || '',
          item.checkInTime || '',
          item.checkOutBy.boothId.name || '',
          item.checkOutTime || '',
          item.parkedTime || '',
          item.parkingFee || '',
        ]);

        // ✅ Step 2: Add total row (adjust this as needed)
        const totalFee = exportDataRaw.reduce((acc, curr) => acc + (curr.parkingFee || 0), 0);
        const lastObj = ["", "", "", "", "", "", "", "", totalFee];
        const finalExportData = [...exportData, lastObj];

        // ✅ Step 3: Define headers
        const exportHeader = [
          "Vehicle",
          "Vehicle Type",
          "Site",
          "Check-In Booth",
          "Check-In Time",
          "Check-Out Booth",
          "Check-Out Time",
          "Parked Time",
          "Fee",
        ];

        // ✅ Step 4: Create worksheet & workbook
        const worksheet = XLSX.utils.aoa_to_sheet([exportHeader, ...finalExportData]);
        worksheet['!cols'] = [
          { wch: 20 }, // Vehicle
          { wch: 15 }, // Vehicle Type
          { wch: 25 }, // Site (bari width di hai)
          { wch: 20 }, // Check-In Booth
          { wch: 25 }, // Check-In Time
          { wch: 20 }, // Check-Out Booth
          { wch: 25 }, // Check-Out Time
          { wch: 15 }, // Parked Time
          { wch: 15 }, // Fee
        ];
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "ParkingCollectionReport");

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

        saveAsExcelFile(excelBuffer, 'ParkingCollectionReport');
      } catch (error) {
        console.error('Export failed:', error);
      }
      finally {
        setExportLoading(false);  // ✅ Stop loading even if error
      }
    };
    const saveAsExcelFile = (buffer, fileName) => {
      import("file-saver").then((module) => {
        if (module && module.default) {
          let EXCEL_TYPE =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
          let EXCEL_EXTENSION = ".xlsx";
          const data = new Blob([buffer], {
            type: EXCEL_TYPE,
          });

          module.default.saveAs(
            data,
            fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
          );
        }
      });
    };

    const storedLoginRes = JSON.parse(localStorage.getItem("user"));
    console.log("storedLoginRes: ", storedLoginRes);
    const userTypeIs = storedLoginRes?.role;
    const userSite = storedLoginRes?.site?._id;
    const isSiteFixed = userTypeIs !== "admin" && !!userSite;
  useEffect(() => {
    if (userTypeIs !== "admin" && userSite) {
      // normal user → auto select site
      formik.setFieldValue("site", userSite);
      setSitevalue(userSite);
      setSiteId(userSite);
    } else {
      // admin → blank by default
      formik.setFieldValue("site", "");
      setSitevalue(null);
      setSiteId("");
    }
    setInitialized(true);
  }, []);

    useEffect(() => {
      const foundSite = siteList?.find((item) => item?._id === userSite);
      setSitevalue(foundSite);
    }, [userSite, siteList]);
    const filteredBoothList = formik.values.site
      ? dashList.filter((booth) => booth.site?._id === formik.values.site)
      : dashList;

    // const formatParkedTime = (minutes) => {
    //   const hours = Math.floor(minutes / 60);
    //   const remainingMinutes = minutes % 60;

    //   // Pad single-digit minutes with leading zero
    //   const formattedMinutes =
    //     remainingMinutes < 10 ? `0${remainingMinutes}` : remainingMinutes;

    //   return `${hours}:${formattedMinutes}`;
    // };
    const handleDateChange = (e) => {
      setFromDate(e.target.value);
      setInitialized(true);
    };
    const formatParkedTime = (minutes) => {
      if (!minutes && minutes !== 0) return "-";
      return `${minutes} min`;
    };
    const footerGroup = (
      <ColumnGroup>
        <Row>
          <Column footer="Total:" colSpan={8} footerStyle={{ textAlign: "right" }} />
          <Column
            footer={new Intl.NumberFormat("en-PK", { style: "currency", currency: "PKR" }).format(totalFee || 0)}
          />
        </Row>
      </ColumnGroup>
    );
    const handlePageChange = (event) => {
      const newPage = event.page + 1;          // PrimeReact pages are 0-based
      const newPageSize = event.rows;

      setCurrentPage(newPage);
      setCurrentPageSize(newPageSize);

      getDashData(newPage, newPageSize);
    };

    const getVehicleTypeList = async () => {
      try {
        const response = await fetch(`${appUrl.BASE_URL}category`);
        const data = await response.json();
        setVehicleTypeList(data);
      } catch (error) {
        console.error(error);
      }
    };
  useEffect(() => {
    if (fromDate && toDate && (siteId || siteId === "")) {
      getDashData(1, currentPageSize);
    }
  }, [fromDate, toDate, siteId]);

    useEffect(() => {
      getVehicleTypeList();
    }, []);
    return (
      <>
        <div className="p-fluid grid">
          {/* Filter, Search, and Export buttons section */}
          <div className="col-12 flex justify-content-end align-items-center">
            <div className="field">
              <InputText
                className="mbl_view mr-2"
                style={{ borderRadius: "100px" }}
                value={globalFilterValue}
                onChange={onGlobalFilterChange}   // 👈 this is fine
                placeholder="Search Registration"
              />
            </div>

            <div className="field ml-3">
              <Button
                label={`Filters (${appliedFilters})`}
                icon="pi pi-filter"
                onClick={() => setShowFilters((prevState) => !prevState)}
                style={{
                  backgroundColor: showFilters ? "" : "transparent",
                  color: showFilters ? "white" : "black",
                  boxShadow: "none",
                  borderRadius: "100px",
                }}
              />
            </div>

            <div className="field ml-3 rounded-lg">
              <Button
                label={exportLoading ? "Exporting..." : "Export to Excel"}
                type="button"
                style={{ borderRadius: "100px" }}
                icon="pi pi-file-excel"
                severity="success"
                disabled={loading || exportLoading}
                onClick={exportExcel}
                data-pr-tooltip="XLS"
              />
            </div>
          </div>

          {/* Filters section, shown when the user clicks on "Filters" */}
          {showFilters && (
            <div className="flex flex-row flex-wrap gap-3 mt-3 w-full mb-3">
              {/* Site Dropdown */}
              <div className="flex-1 min-w-[200px]">
                <Dropdown
                  id="site"
                  name="site"
                  value={formik.values.site}
                  onChange={(e) => {
                    formik.handleChange(e);
                    setSiteId(e.target.value);
                  }}
                  filter
                  filterBy="site"
                  filterMatchMode="contains"
                  className={classNames(
                    { "p-invalid": isFormFieldValid("site") },
                    "w-full TextArea__Round border-round-3xl"
                  )}
                  options={siteList}
                  optionLabel="site"
                  optionValue="_id"
                  placeholder="Select Site"
                  disabled={isSiteFixed || !!queryParams.get("site")}  
                  showClear
                />
                {getFormErrorMessage("site")}
              </div>

              {/* Booth Dropdown */}
              <div className="flex-1 min-w-[200px]">
                <Dropdown
                  id="boothId"
                  name="boothId"
                  value={formik.values.boothId}
                  onChange={(e) => {
                    formik.handleChange(e);
                    setBooothId(e.target.value);
                  }}
                  filter
                  filterBy="boothId"
                  filterMatchMode="contains"
                  className={classNames(
                    { "p-invalid": isFormFieldValid("boothId") },
                    "w-full TextArea__Round border-round-3xl"
                  )}
                  options={boothList}
                  optionLabel="name"
                  optionValue="_id"
                  placeholder="Select Booth"
                  disabled={isSiteFixed || !!queryParams.get("site")}
                  showClear
                />
                {getFormErrorMessage("boothId")}
              </div>
              <div className="flex-1 min-w-[200px]">
                <Dropdown
                  id="vehicleType"
                  name="vehicleType"
                  value={selectedVehicleType}
                  onChange={(e) => setSelectedVehicleType(e.value)}
                  filter
                  filterBy="name"
                  filterMatchMode="contains"
                  className="w-full TextArea__Round border-round-3xl"
                  options={vehicleTypeList}
                  optionLabel="name"
                  optionValue="_id"   // ✅ Send _id, not name
                  placeholder="Select Vehicle Type"
                  showClear
                />
              </div>

              {/* From Date */}
              <div className="flex-1 min-w-[160px]">
                <InputText
                  id="fromDate"
                  name="fromDate"
                  value={fromDate}
                  onChange={handleDateChange}
                  type="date"
                  placeholder="From Date"
                  className="w-full border-round-3xl"
                  readOnly={loading}
                />
              </div>

              {/* To Date */}
              <div className="flex-1 min-w-[160px]">
                <InputText
                  id="toDate"
                  name="toDate"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  type="date"
                  placeholder="To Date"
                  className="w-full border-round-3xl"
                  readOnly={loading}
                />
              </div>
 
              {/* Search Button - Align right */}
              <div className="flex justify-content-end align-items-center" style={{ flexGrow: 1 }}>
                <Button
                  label="Search"
                  icon="pi pi-search"
                  className="p-button-rounded p-button-info ml-auto"
                  onClick={() => {
                    setInitialized(true);
                    getDashData();
                  }}
                  disabled={loading}
                />
              </div>
            </div>
          )}

        </div>


        {dashStat === undefined ? (
          <h1>Loading...</h1>
        ) : (
          <div className="grid">
            <div className="col-12 md:col-12">
              <div className="card">
                <div className="flex justify-content-end mb-4"> </div>

                <DataTable
                  value={dashList}
                  footerColumnGroup={footerGroup}
                  paginator
                  rows={currentPageSize}                          // ✅ Correct page size
                  totalRecords={totalRecords}                     // ✅ Correct total records
                  first={(currentPage - 1) * currentPageSize}     // ✅ Correct starting index
                  onPage={(e) => {
                    const newPage = e.page + 1;
                    const newPageSize = e.rows;  // 👈 Ye line missing thi

                    setCurrentPage(newPage);
                    setCurrentPageSize(newPageSize);

                    getDashData(newPage, newPageSize, globalFilterValue);  // ✅ Now this works
                  }}
                  loading={loading}
                  lazy                                           // ✅ This tells PrimeReact to handle server-side pagination
                  scrollable
                  emptyMessage="No records found"
                >
                  <Column
                    header="ID"
                    body={(rowData) => (
                      <div title={rowData._id} style={{ cursor: "pointer" }}>
                        {`${rowData._id?.slice(0, 6)}...${rowData._id?.slice(
                          -6
                        )}`}
                      </div>
                    )}
                  />
                  <Column field="site" header="Site Name" />
                  <Column field="vehicleType" header="Vehicle" />
                  <Column field="vehicleRegNumber" header="Registration" />
                  {/* <Column
                      field="exempted"
                      header="Exempted"
                      body={(rowData) => (rowData.exempted ? "Yes" : "No")}
                    /> */}

                  <Column
                    field="checkInTime"
                    header="Check-In"
                    body={(rowData) => {
                      if (!rowData.checkInTime) return '-';
                      return moment.utc(rowData.checkInTime).format("hh:mm:ss A YYYY-MM-DD ");
                    }}
                  />
                  <Column field="checkInBy" header="Check-In Booth" />
                  <Column
                    field="checkOutTime"
                    header="Check-Out"
                    body={(rowData) => {
                      if (!rowData.checkOutTime) return '-';
                      return moment.utc(rowData.checkOutTime).format("hh:mm:ss A YYYY-MM-DD ");
                    }}
                  />
                  <Column field="checkOutBy" header="Check-Out Booth" />
                  <Column
                    field="parkingFee"
                    header="Parking Fee"
                    body={(rowData) =>
                      new Intl.NumberFormat("en-PK", {
                        style: "currency",
                        currency: "PKR",
                      }).format(rowData.parkingFee)
                    }
                  />
                  <Column
                    field="parkedTime"
                    header="Park Time"
                    body={(rowData) => formatParkedTime(rowData.parkedTime)}
                  />
                </DataTable>

              </div>
            </div>
          </div>
        )}
      </>
    );
  };

  export default CollectionReports;
